import { Extension, Node } from "@tiptap/react";

/**
 * A generic Div node so pasted/imported HTML keeps its <div> wrappers
 * (with inline background, color, padding, etc).
 */
export const DivNode = Node.create({
  name: "div",
  group: "block",
  content: "block*",
  defining: true,
  addAttributes() {
    return {
      style: {
        default: null,
        parseHTML: (el) => el.getAttribute("style"),
        renderHTML: (attrs) => (attrs.style ? { style: attrs.style } : {}),
      },
      class: {
        default: null,
        parseHTML: (el) => el.getAttribute("class"),
        renderHTML: (attrs) => (attrs.class ? { class: attrs.class } : {}),
      },
      bgcolor: {
        default: null,
        parseHTML: (el) => el.getAttribute("bgcolor"),
        renderHTML: (attrs) => (attrs.bgcolor ? { bgcolor: attrs.bgcolor } : {}),
      },
    };
  },
  parseHTML() {
    return [{ tag: "div" }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", HTMLAttributes, 0];
  },
});

/**
 * Preserves inline `style`, `class`, and `bgcolor` attributes on common nodes
 * so pasted/imported HTML keeps colors, backgrounds, padding, borders, etc.
 */
export const PreserveStyles = Extension.create({
  name: "preserveStyles",
  addGlobalAttributes() {
    const styledTypes = [
      "paragraph",
      "heading",
      "tableCell",
      "tableHeader",
      "tableRow",
      "table",
      "image",
      "bulletList",
      "orderedList",
      "listItem",
      "horizontalRule",
      "textStyle",
      "div",
    ];

    return [
      {
        types: styledTypes,
        attributes: {
          style: {
            default: null,
            parseHTML: (element) => element.getAttribute("style"),
            renderHTML: (attributes) => {
              if (!attributes.style) return {};
              return { style: attributes.style };
            },
          },
          class: {
            default: null,
            parseHTML: (element) => element.getAttribute("class"),
            renderHTML: (attributes) => {
              if (!attributes.class) return {};
              return { class: attributes.class };
            },
          },
          bgcolor: {
            default: null,
            parseHTML: (element) => element.getAttribute("bgcolor"),
            renderHTML: (attributes) => {
              if (!attributes.bgcolor) return {};
              return { bgcolor: attributes.bgcolor };
            },
          },
        },
      },
    ];
  },
});
